require('./dealer-cta-item.tag');
require('./dealer-start-reservation-cta.tag');

riot.tag2('dealer-ctas', '<dealer-cta-item if="{!isStartReservation}" each="{link , index+props.dealer-index in ctas.buttons}"></dealer-cta-item> <dealer-start-reservation-cta if="{isStartReservation}" dealer-web-address="{this.opts.dealer.ReserveVehicle}"></dealer-start-reservation-cta>', '', 'class="dealer-ctas"', function(opts) {
      var self = this;
      self.isStartReservation =  this.opts.isStartReservation ? this.opts.isStartReservation : false;
});
